let mapInit = function () {
  const mapElement = document.getElementById('map');

  if (mapElement === null) {
    return;
  }

  const loc = {lat: 37.371139, lng: -121.925589};

  let map = new google.maps.Map(mapElement, {
    center: loc,
    zoom: 17,
    disableDefaultUI: true
  });

  let marker = new google.maps.Marker({
    position: loc,
    map: map
  });
};
export default mapInit;



// WEBPACK FOOTER //
// ./app/blocks/map/map.js